<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in comList" :label="item.title + `(${pageTotal[item.name] || 0})`" :name="item.name" lazy
        :key="item.name">
      </el-tab-pane>
      <InterForm @querySubmit="queryHandler" @overEmit="getDataSource" prentType="largeBag" :tableType="tableType"
        :forwarder="forwarder" ref="InterForm" />

      <InterBtnBox :selectedRows="selectedRows" :forwarder="forwarder" :InterForm="$refs.InterForm"
        @overEmit="getDataSource" prentType="largeBag" :tableType="tableType" @refeash="refeash" />

      <InterList :tableType="tableType" @refeash="refeash" :dataSource="dataSource" :clean='clean'
        @pageChange="pageChangeCall" @selectChange="selectChangeCall" prentType="largeBag" ref="interlist"
        :forwarder="forwarder" :total="query.total" :customsList="customsList" :compilationMethodList="compilationMethodList" :reasonList="reasonList"></InterList>
    </el-tabs>
  </div>
</template>

<script>

import InterForm from './components/InterForm'
import InterList from "./components/InterList";
import InterBtnBox from "./components/InterBtnBox";
import { deliveryReviewPage, getClientForwarder } from "@/apis/outStock";
import { processingStatusList, deliveryTypes } from "./data";

export default {
  title: '大包发货',
  name: "largeBagShip",
  components: {
    InterForm,
    InterBtnBox, InterList
  },
  data() {
    return {
      activeName: 'ToBeProcessed',
      forwarder: [],
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      clean: false,
      selectedRows: [],
      dataSource: [],
      tableType: 'ToBeProcessed',
      pageTotal: {}
    }
  },
  created() {
  },
  props:{
    compilationMethodList: {
      type: Array,
      default: () => []
    },
    customsList: {
      type: Array,
      default: () => []
    },
    reasonList: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    comList: function () {
      return [{ name: 'ToBeProcessed', title: '待处理' }, { name: 'warning', title: '异常' }, { name: 'ToBeConfirm', title: '待确认' }, { name: 'Completed', title: '已处理' }]
    }
  },
  methods: {
    handleClick(e) {
      this.tableType = e.name
      this.queryHandler()
    },
    queryHandler: function (payload) {
      console.log(payload)
      console.log(this)
      this.query = {
        ...this.query,
        ...payload,
      };
      this.query.current = 1
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows;
    },
    refeash() {
      this.getDataSource(false)
      // if (this.$refs.interlist) {
      //   this.$refs.interlist.resetPage()
      // }
    },
    getDataSource: function (refeash = true) {
      // 获取列表数据
      this.selectedRows = [];
      const params = {
        ...this.query,
        pageNum: this.query.current,
        processingStatus: processingStatusList[this.tableType],
        deliveryType: deliveryTypes["largeBag"],
      };
      this.clean = true;
      deliveryReviewPage(params)
        .then((res) => {
          if (res.code != 0) {
            return
          }
          const {
            data: { deliveryReviewPage: { total = 0, records = [] }, processingStatusCount },
          } = res;

          records.forEach(item => {
            //列表显示的货代信息
            item.auditIntForwarderConfigIdDesc = item.auditForwarder + '-' + item.auditShippingType
            item.forwarderDesc = (item.forwarder == '无可用货代公司' ? '无可用货代公司' :item.forwarder + '-' + item.shippingType)
            item.deliveryReviewSpuList.forEach(spu=>{
              spu.auditIntForwarderConfigIdDesc = spu.auditIntForwarderConfigId != 0 ? spu.auditIntForwarderConfigId == -1 ? '无可用货代公司' : (spu.auditForwarder + '-' + spu.auditShippingType):'请选择'
              spu.deliveryReviewDetailList.forEach(sku=>{
                sku.auditIntForwarderConfigIdDesc = sku.auditIntForwarderConfigId != 0 ? sku.auditIntForwarderConfigId == -1 ? '无可用货代公司' : (sku.auditForwarder + '-' + sku.auditShippingType):'请选择'
                sku.onShowPrice = sku.currencyCode == 'KRW' ? sku.customsPriceKr : sku.customsPrice
              })
            })
          })
          records.forEach(item => {
            item.deliveryReviewSpuList.forEach(item2 => {
              item2.id = item2.productCode
            })
            item.deliveryReviewSpuList = item.deliveryReviewSpuList.sort((v1,v2)=>{
              return  hasError(v2) - hasError(v1) 
              function hasError(item){
                return item.deliveryReviewDetailList.filter(v=>(v.auditReasonCode && v.auditReasonCode !== 'AR_0000') || Number(v.auditIntForwarderConfigId)).length
              }
            }).map((item) => {
              return {
                ...item,
                deliveryReviewDetailList: item.deliveryReviewDetailList?.map((v) => {
                  return {
                    ...v,
                    attrCodes: v.productTransportationAttrDTOS?.map(i => i.code)
                  }
                })
              }
            })
          })
          refeash && (this.query.total = total);
          this.dataSource = records;
          this.pageTotal = {
            ToBeProcessed: processingStatusCount.pending,
            ToBeConfirm: processingStatusCount.toBeConfirmed,
            Completed: processingStatusCount.processed,
            warning:processingStatusCount.abnormal
          }
          // const {}
        })
        .finally((_) => {
          this.clean = false;
        });
      getClientForwarder({
        processingStatus: processingStatusList[this.tableType],
        deliveryType: 1
      }).then(res => {
        if (res.code == 0) {
          this.forwarder = [{
            forwarder: '无可用货代公司',
            intForwarderConfigId: '-1',
            shippingType: 0
          }].concat(res.data)
          if (res.data.length == 0) {
            this.$message.warning('货代公司请求失败')
          }
        }
      })
    },
  },
}
</script>

<style scoped>

</style>